export default __webpack_public_path__ + "static/product-photo-1cd3421b4a716e9c0268734775b98d4c.png";